import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./config/language/en/en.json";
import kr from "./config/language/kr/kr.json";
import ja from "./config/language/ja/ja.json";
import talentEn from "./config/language/en/talentEn.json";
import talentKr from "./config/language/kr/talentKr.json";
import talentJa from "./config/language/ja/talentJa.json";
import businessEn from "./config/language/en/businessEn.json";
import businessKr from "./config/language/kr/businessKr.json";
import businessJa from "./config/language/ja/businessJa.json";
import gtpEn from "./config/language/en/gtpEn.json";
import gtpKr from "./config/language/kr/gtpKr.json";
import gtpJa from "./config/language/ja/gtpJa.json";
import userProfileEn from "./config/language/en/userProfileEn.json";
import userProfileKr from "./config/language/kr/userProfileKr.json";
import userProfileJa from "./config/language/ja/userProfileJa.json";
import aiTwinEn from "./config/language/en/aiTwinEn.json";
import aiTwinKr from "./config/language/kr/aiTwinKr.json";
import aiTwinJa from "./config/language/ja/aiTwinJa.json";
import notificationEn from "./config/language/en/notificationEn.json";
import notificationKr from "./config/language/kr/notificationKr.json";
import notificationJa from "./config/language/ja/notificationJa.json";
import staiUserEn from "./config/language/en/staiUserEn.json";
import staiUserKr from "./config/language/kr/staiUserKr.json";
import staiUserJa from "./config/language/ja/staiUserJa.json";
import airbankEn from "./config/language/en/airbankEn.json";
import airbankKr from "./config/language/kr/airbankKr.json";
import taascardsEn from "./config/language/en/taascardEn.json";
import taascardsKr from "./config/language/kr/taascardKr.json";
import taascardsJa from "./config/language/ja/taascardJa.json";
import inboxEn from "./config/language/en/inboxEn.json";
import inboxKr from "./config/language/kr/inboxKr.json";
import inboxJa from "./config/language/ja/inboxJa.json";

const storedLang = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  lng: storedLang as "en" | "kr" | "ja",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      common: en,
      talent: talentEn,
      business: businessEn,
      gtp: gtpEn,
      userProfile: userProfileEn,
      aiTwin: aiTwinEn,
      notification: notificationEn,
      staiUser: staiUserEn,
      airbank: airbankEn,
      taascard: taascardsEn,
      inbox: inboxEn,
    },
    kr: {
      common: kr,
      talent: talentKr,
      business: businessKr,
      gtp: gtpKr,
      userProfile: userProfileKr,
      aiTwin: aiTwinKr,
      notification: notificationKr,
      staiUser: staiUserKr,
      airbank: airbankKr,
      taascard: taascardsKr,
      inbox: inboxKr,
    },
    ja: {
      common: ja,
      talent: talentJa,
      business: businessJa,
      gtp: gtpJa,
      userProfile: userProfileJa,
      aiTwin: aiTwinJa,
      notification: notificationJa,
      staiUser: staiUserJa,
      airbank: airbankEn,
      taascard: taascardsJa,
      inbox: inboxJa,
    },
  },
  ns: [
    "common",
    "talent",
    "business",
    "gtp",
    "userProfile",
    "aiTwin",
    "notification",
    "staiUser",
    "airbank",
    "taascard",
    "inbox",
  ],
  defaultNS: "common",
});
export default i18n;
